import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="snap-scroll"
export default class extends Controller {
  static targets = ["prev", "next", "inner"]   // Add targets for buttons + scroll container

  connect() {
    const container = this.innerTarget || this.element.querySelector('.snap-scroll-inner')
    if (!container) return

    this.container = container

    // Initial button state
    this.updateButtons()

    // Update on scroll
    this.container.addEventListener('scroll', this.updateButtons.bind(this))

    // Update after resize (e.g. window resize or content changes)
    window.addEventListener('resize', this.updateButtons.bind(this))
  }

  disconnect() {
    if (this.container) {
      this.container.removeEventListener('scroll', this.updateButtons.bind(this))
    }
    window.removeEventListener('resize', this.updateButtons.bind(this))
  }

  updateButtons() {
    if (!this.container) return

    const { scrollLeft, scrollWidth, clientWidth } = this.container

    const isAtStart = scrollLeft <= 1          // small tolerance
    const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1

    // Disable/enable Prev button
    if (this.hasPrevTarget) {
      this.prevTarget.disabled = isAtStart
    }

    // Disable/enable Next button
    if (this.hasNextTarget) {
      this.nextTarget.disabled = isAtEnd
    }
  }

  next() {
    if (!this.container) return
    const scrollAmount = this.innerTargets[0].getElementsByClassName('snap-item')[0].clientWidth
    this.container.scrollBy({ left: scrollAmount, behavior: 'smooth' })
  }

  prev() {
    if (!this.container) return
    const scrollAmount = this.innerTargets[0].getElementsByClassName('snap-item')[0].clientWidth
    this.container.scrollBy({ left: -scrollAmount, behavior: 'smooth' })
  }
}
